import { Button, DatePicker, Input, Space, Typography } from 'antd';
import dayjs from 'dayjs';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const { Text } = Typography;

export function TaskRow({ task, onSubmit }) {
  const [answer, setAnswer] = useState('');
  const [saving, setSaving] = useState('');

  const handleSubmit = async (val) => {
    const submitValue = val !== undefined ? val : answer;
    if (!submitValue) return;
    setSaving(submitValue);
    await onSubmit(task.partnerOnboardingId, task.templateId, submitValue);
    setSaving('');
    setAnswer('');
  };

  const isYesNo = task.inputType === 'YES_NO';
  const naButton = task.allowNotApplicable ? (
    <Button
      size="small"
      onClick={() => handleSubmit('N/A')}
      loading={saving === 'N/A'}
      disabled={!!saving}
    >
      N/A
    </Button>
  ) : null;

  return (
    <div style={{ padding: '10px 0', borderBottom: '1px solid #f0f0f0' }}>
      <div style={{ marginBottom: 6 }}>
        <Text>{task.taskName}</Text>
        <Text type="secondary" style={{ marginLeft: 8, fontSize: 12 }}>
          {task.daysToComplete}d SLA
        </Text>
      </div>
      <Space>
        {isYesNo && (
          <>
            <Button
              type="primary"
              size="small"
              onClick={() => handleSubmit('Yes')}
              loading={saving === 'Yes'}
              disabled={!!saving}
            >
              ✓ Yes
            </Button>
            <Button
              size="small"
              onClick={() => handleSubmit('No')}
              loading={saving === 'No'}
              disabled={!!saving}
            >
              ✗ No
            </Button>
          </>
        )}
        {task.inputType === 'DATE' && (
          <>
            <DatePicker
              value={answer ? dayjs(answer) : dayjs()}
              onChange={(_, s) => setAnswer(s)}
              defaultValue={dayjs()}
            />
            {/* The picker shows today by default; submit that when untouched. */}
            <Button
              type="primary"
              size="small"
              onClick={() =>
                handleSubmit(answer || dayjs().format('YYYY-MM-DD'))
              }
              loading={!!saving && saving !== 'N/A'}
              disabled={!!saving}
            >
              Save
            </Button>
          </>
        )}
        {(task.inputType === 'TEXT' || task.inputType === 'FORM') && (
          <>
            <Input
              value={answer}
              onChange={(e) => setAnswer(e.target.value)}
              placeholder={
                task.inputType === 'FORM'
                  ? 'Enter form reference or notes'
                  : 'Enter answer'
              }
              style={{ width: 280 }}
            />
            <Button
              type="primary"
              size="small"
              onClick={() => handleSubmit()}
              loading={!!saving && saving !== 'N/A'}
              disabled={!answer}
            >
              Save
            </Button>
          </>
        )}
        {naButton}
      </Space>
    </div>
  );
}

export function PartnerGroup({
  partnerOnboardingId,
  contactId,
  contactName,
  region,
  regionName,
  tasks,
  onSubmit,
}) {
  const regionLabel = regionName || region;
  const displayName = contactName || partnerOnboardingId;
  return (
    <div style={{ marginBottom: 24 }}>
      <Space style={{ marginBottom: 4 }}>
        {contactId ? (
          <Link
            to={`/contact/view/${contactId}/partner-onboarding`}
            style={{ fontSize: 16, fontWeight: 600 }}
          >
            {displayName}
          </Link>
        ) : (
          <Text strong style={{ fontSize: 16 }}>
            {displayName}
          </Text>
        )}
        <Text type="secondary" style={{ fontSize: 12 }}>
          {regionLabel}
        </Text>
      </Space>
      {tasks.map((task) => (
        <TaskRow key={task.templateId} task={task} onSubmit={onSubmit} />
      ))}
    </div>
  );
}
